// Third Party
import React from 'react';

// Components
import { formatMessage, FormattedMessage, LOCALE } from '../../../utils/i18n';
import { SelectInput, SelectOption } from '../../components/inputs';

// Utils
import Locale from '@/types/locale';

type Props = {
  locale: Locale;
  onLocaleChange: (locale: Locale) => void;
};

const AuthFooter = ({ locale, onLocaleChange }: Props) => {
  const localePath = locale === LOCALE.FR_CA ? 'fr' : 'en';

  const filteredOptions = () =>
    [
      {
        hidden: locale === LOCALE.EN_US,
        label: formatMessage(`Common.Language.${LOCALE.EN_CA}`),
        value: LOCALE.EN_CA,
      },
      {
        hidden: locale === LOCALE.EN_CA || locale === LOCALE.FR_CA,
        label: formatMessage(`Common.Language.${LOCALE.EN_US}`),
        value: LOCALE.EN_US,
      },
      {
        label: formatMessage(`Common.Language.${LOCALE.FR_CA}`),
        value: LOCALE.FR_CA,
      },
    ].filter(i => !i.hidden);

  return (
    <div className="auth-footer d-flex">
      <div className="d-flex container justify-content-between align-items-center">
        <div className="align-items-start">
          <span className="copyright">©{new Date().getFullYear()} CapIntel Inc.</span>
        </div>

        <ul className="auth-navigation align-items-center d-flex">
          <li>
            <a href={`https://capintel.com/${localePath}/terms/`} target="_blank" rel="noopener noreferrer">
              <FormattedMessage id="Auth.Nav.TermsOfUse" />
            </a>
          </li>
          <li>
            <a href={`https://capintel.com/${localePath}/privacy/`} target="_blank" rel="noopener noreferrer">
              <FormattedMessage id="Auth.Nav.PrivacyPolicy" />
            </a>
          </li>
          {[LOCALE.EN_CA, LOCALE.FR_CA].includes(locale as LOCALE) && (
            <li className="language-selector">
              <i className="icon-globe" />
              <SelectInput onValueChange={onLocaleChange} selected={locale} className="dropdown-above">
                {filteredOptions().map(option => (
                  <SelectOption key={option.value} value={option.value}>
                    {option.label}
                  </SelectOption>
                ))}
              </SelectInput>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default AuthFooter;
